import React, { memo } from "react";
import { motion } from "framer-motion";
import { Task } from "@/modules/snapshots/grid/sidebar/search/components/taskProgress/taskTypes";
import { SearchProgressMetrics } from "@/modules/snapshots/grid/sidebar/search/useSearchProgress";

export interface Props {
  task: Task;
  status: "pending" | "active" | "completed";
  metrics: SearchProgressMetrics;
  thinking?: string;
  relevantFields?: string[];
  documents?: number;
}

export const TaskProgressDetails: React.FC<Props> = memo(({ task, metrics, thinking, status }) => {
  if (task.id === "thinking" && thinking) {
    return (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2 }}
        className="space-y-2"
      >
        <p className="line-clamp-3 text-sm font-medium text-gray-800">{thinking}</p>
      </motion.div>
    );
  }

  if (task.id === "analyzing" && status === "active") {
    return (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2 }}
        className="space-y-2"
      >
        <div className="flex items-center justify-between gap-2 text-xs">
          <span className="text-gray-700">
            Analyzing: <span className="font-semibold">{metrics.resultCount}</span> of{" "}
            <span className="font-semibold">{metrics.documentCount}</span>
          </span>
          <span className="text-gray-700">{metrics.progressPercentage}%</span>
        </div>
      </motion.div>
    );
  }

  return null;
});
